export const CHANNEL_PROGRAMS_RESET_STATE = 'CHANNEL_PROGRAMS_RESET_STATE';
export const CHANNEL_PROGRAMS_CURRENT_ITEM = 'CHANNEL_PROGRAMS_CURRENT_ITEM';

export const CHANNEL_PROGRAMS_REQUEST_LOADING = 'CHANNEL_PROGRAMS_REQUEST_LOADING';
export const CHANNEL_PROGRAMS_REQUEST_SUCCESS = 'CHANNEL_PROGRAMS_REQUEST_SUCCESS';
export const CHANNEL_PROGRAMS_REQUEST_FAILED = 'CHANNEL_PROGRAMS_REQUEST_FAILED';

export const CHANNEL_PROGRAMS_CURRENT_ACTION = 'CHANNEL_PROGRAMS_CURRENT_ACTION';
export const CHANNEL_PROGRAMS_RESET_ACTION = 'CHANNEL_PROGRAMS_RESET_ACTION';